import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  background: #4885ed;
  border-radius: 50%;
  box-shadow: inset 0px -6px 59px -21px rgba(0,0,0,0.32), 3px 23px 16px -18px rgba(0,0,0,0.4);
  animation: zoom_in 400ms ease-in-out;
  transform-origin: center center;
  &.lds-ripple {
    display: inline-block;
    position: absolute;
    width: 72px;
    height: 72px;
  }
  &.lds-ripple div {
    position: absolute;
    border: 4px solid #fff;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite ;
  }
  &.lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
  @keyframes zoom_in {
    0% {
      transform: scale(0)

    }
    100% {
      transform: scale(1)
    }
  }
`;

const Spinner = () => {
  return (
    <Wrapper className="lds-ripple" data-testid="loading-spinner">
      <div></div>
      <div></div>
    </Wrapper>
  )
}

export default Spinner
